// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".center[data-v-7cc09ff6]{text-align:center;margin-top:45px}.play-button[data-v-7cc09ff6]{width:420px;height:420px;position:absolute;top:60%;left:48%;transform:translate(-50%,-50%);z-index:99999;margin-top:50px}video[data-v-7cc09ff6]{width:70%}@media (max-width:1000px){video[data-v-7cc09ff6]{width:100%}.play-button[data-v-7cc09ff6]{width:120px;height:120px;top:63%;left:51%}}", ""]);
// Exports
module.exports = exports;
